export const OFFER_RECOMMENDED_FLAGS = [
  "offer_revisions",
  "offer_checklist",
  "offer_calculation_v2",
  "offer_v2_overview",
  "offer_document_builder",
];

export function offerSetupIssues({ flags, recommended, loadError } = {}) {
  if (loadError) return ["load"];
  if (!flags || typeof flags !== "object") return [];

  const rec =
    Array.isArray(recommended) && recommended.length > 0
      ? recommended
      : OFFER_RECOMMENDED_FLAGS;

  return rec.filter((key) => !flags[key]);
}
